<template>
  <ul class="flex-center">
    <li
      v-for="(item, i) in data"
      :key="i"
      @click="goTo(item.url, item.trackName)"
    >
      <a-dropdown placement="bottom" :trigger="['hover']">
        <div class="flex-center">
          <span class="value font-size-15 color-4e5969 margin-r-5">
            {{ item.value }}
          </span>
          <img
            src="https://ali-file-cdn.iol8.com/img/icon/down_32-32.png"
            width="16"
            height="16"
            v-if="item.list && item.list.length > 0"
          />
        </div>
        <template #overlay>
          <div class="dropdown-box" v-if="item.list">
            <div class="display-flex">
              <div>
                <p
                  v-if="item.isTitle"
                  class="font-size-12 color-4e5969 font-weight-500 padding-lr-16 margin-b-12"
                >
                  快速开始
                </p>
                <div
                  class="item display-flex align-center"
                  v-for="(li, j) in item.list"
                  :key="li.title"
                  @click="goTo(li.url, li.trackName)"
                  :class="li.url === '/home' && 'item-active'"
                >
                  <img :src="li.icon" width="48" height="48" />
                  <div class="margin-l-12">
                    <p class="font-size-15 color-4e5969 font-weight-600">
                      {{ li.title }}
                    </p>
                    <p class="font-size-12 color-999 margin-t-6">
                      {{ li.description }}
                    </p>
                  </div>
                  <img
                    src="https://ali-file-cdn.iol8.com/img/icon/down_32-32.png "
                    width="16"
                    height="16"
                    class="icon-box"
                  />
                  <!-- <div v-if="li.list" class="help-box">
                    <div v-for="(t, i) in li.list" :key="i">
                      <div
                        class="display-flex align-center help-item"
                        @click="goTo(t.url, t.trackName)"
                      >
                        <div
                          class="h-full flex align-center justify-center text-sm text-1c2129 font-semibold"
                        >
                          {{ t.title }}
                        </div>
                        <img
                          src="https://ali-file-cdn.iol8.com/img/icon/down_32-32.png "
                          width="16"
                          height="16"
                          class="help-icon"
                        />
                      </div>
                    </div>
                  </div> -->
                  <!-- 帮助中心hover补位 -->
                  <!-- <div v-if="li.list" class="item item-space"></div> -->
                </div>
              </div>
              <div class="more-box" v-if="item.more && item.more.length > 0">
                <p
                  class="font-size-12 color-4e5969 font-weight-500 padding-lr-16 margin-b-12"
                >
                  更多
                </p>
                <div
                  class="item display-flex align-center"
                  v-for="(li, j) in item.more"
                  :key="li.title"
                  @click="goTo(li.url, li.trackName)"
                >
                  <img :src="li.icon" width="48" height="48" />
                  <div class="margin-l-12">
                    <p class="font-size-15 color-4e5969 font-weight-600">
                      {{ li.title }}
                    </p>
                    <p class="font-size-12 color-999 margin-t-6">
                      {{ li.description }}
                    </p>
                  </div>
                  <img
                    src="https://ali-file-cdn.iol8.com/img/icon/down_32-32.png "
                    width="16"
                    height="16"
                    class="icon-box"
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
      </a-dropdown>
    </li>
  </ul>
</template>

<script setup>
  import { useRouter } from 'vue-router'
  import { ref } from 'vue'

  import { trackStatistics } from '@/utils/tracker/index'
  import { trackMap } from '@/utils/tracker/trackData'

  const data = ref([
    {
      value: '人机共译',
      isTitle: true,
      list: [
        {
          icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-1.png',
          title: '个人版',
          description: 'AI智能辅助，专注翻译',
          url: '/go/tsp_pc_login_option/personal',
          trackName: 'pe-personal',
        },
        {
          icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-2.png',
          title: '企业版',
          description: '多人合作，项目实时管理',
          url: '/go/tsp_pc_login_option/team',
          trackName: 'pe-team',
        },
        {
          icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-3.png',
          title: '翻译工具',
          description: '语料对齐、术语提取等工具',
          url: '/home',
          trackName: 'iol-home',
        },
      ],
      more: [
        {
          icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-4.png',
          title: '会员定价',
          description: '专享高级功能与充值折扣',
          url: '/go/tsp_pc_login_option/home/price',
          trackName: 'tsp-price',
        },
      ],
    },
    {
      value: '孪生引擎',
      isTitle: false,
      url: '/go/tw_pc_login_option',
      trackName: 'tw-home',
    },
    {
      value: '任务中心',
      isTitle: false,
      url: '/go/wd_pc_login/web/orders',
      // list: [
      //   {
      //     icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-10.png',
      //     title: '线上订单',
      //     description: '在线翻译',
      //     url: '/go/wd_pc_login/web/dot/pe',
      //     trackName: 'wd-task',
      //   },
      //   {
      //     icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-11.png',
      //     title: '线下订单',
      //     description: '本地翻译',
      //     url: '/go/wd_pc_login/task/center',
      //     trackName: 'wd-task-center',
      //   },
      //   {
      //     icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-12.png',
      //     title: '译员招募',
      //     description: '泛语言岗位信息',
      //     url: '/go/wp_pc_login_option/chance/recommendAll',
      //     trackName: 'wp-recommendAll',
      //   },
      // ],
    },
    {
      value: '译客社区',
      isTitle: false,
      list: [
        {
          icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-5.png',
          title: '圈子',
          description: '加入译员专属圈子互动吧',
          url: '/go/wd_pc_login_option/circle/center',
          trackName: 'wd-qz',
        },
        {
          icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-6.png',
          title: '课程',
          description: '翻译精品课堂等您来参与',
          url: '/go/wp_pc_login_option/classIndex',
          trackName: 'wp-class',
        },
        {
          icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-13.png',
          title: '活动中心',
          description: '最新精彩活动不要错过哦',
          url: '/go/tsp_pc_login_option/activity',
          trackName: 'tsp-activity',
        },
        {
          icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-14.png',
          title: '社区广场',
          description: '分享翻译心得抢专属红包',
          url: '/go/wd_pc_login_option/web/square',
          trackName: 'wd-square',
        },
      ],
    },
    {
      value: '关于我们',
      isTitle: false,
      list: [
        {
          icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-7.png',
          title: '版本动态',
          description: '快速了解产品更新内容',
          url: '/go/tsp_pc_login_option/version',
          trackName: 'tsp-version',
        },
        {
          icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-8.png',
          title: '联系我们',
          description: '欢迎向我们咨询和反馈',
          url: '/go/tsp_pc_login_option/about',
          trackName: 'tsp-about',
        },
        {
          icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-9.png',
          title: '帮助中心',
          description: '常见问题快速找到答案',
          url: '/go/tsp_pc_login_option/helpCenter',
          trackName: 'tsp-help-center',
          // list: [
          //   {
          //     title: '订单帮助',
          //     url: '/go/wd_pc_login_option/about/faq',
          //     trackName: 'wd-faq',
          //   },
          //   {
          //     title: '工具帮助',
          //     url: '/go/pe_pc/docs/',
          //     trackName: 'pe-docs',
          //   },
          // ],
        },
      ],
    },
  ])

  const router = useRouter()
  const goTo = (url, trackName) => {
    if (!url) return
    trackName &&
      trackStatistics({
        event_code: 'topNavigation',
        scene_code: trackMap[trackName] || '',
      })
    if (url.includes('go')) {
      window.open(url, '_blank')
    } else {
      router.push(url)
    }
  }
</script>

<style lang="less" scoped>
  ul {
    li {
      margin-right: 40px;
      cursor: pointer;
      &:hover {
        .value {
          color: #000;
          font-weight: 500;
        }
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .dropdown-box {
    margin-top: 14px;
    padding: 30px;
    background: #ffffff;
    box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.12);
    border-radius: 12px;
    border: 1px solid #f2f3f5;
    .more-box {
      margin-left: 30px;
      padding-left: 30px;
      border-left: 1px solid #f2f3f5;
    }
    .item {
      position: relative;
      padding: 16px;
      width: 280px;
      cursor: pointer;
      .icon-box {
        position: absolute;
        top: 30px;
        right: 20px;
        width: 12px;
        transform: translate(0, -50%);
        display: none;
        transform: rotate(-90deg);
        svg {
          font-size: 12px;
        }
      }
      &:hover {
        background: #f2f3f5;
        border-radius: 12px;
        .icon-box {
          display: block;
        }
        .help-box {
          display: block;
        }
      }
    }
    .item-active {
      background: #f2f3f5;
      border-radius: 12px;
      .icon-box {
        display: block;
      }
    }
  }
  .help-box {
    display: none;
    position: absolute;
    top: -25px;
    right: -215px;
    width: 200px;
    height: 136px;
    padding: 20px;
    background: #fff;
    box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.12);
    border-radius: 12px;
    border: 1px solid #f2f3f5;
  }
  .help-item {
    position: relative;
    height: 48px;
    padding: 0 20px;
    background: #fff;
    border-radius: 8px;
    .help-icon {
      position: absolute;
      top: 16px;
      right: 16px;
      transform: translate(0, -50%);
      display: none;
      transform: rotate(-90deg);
    }
    &:hover {
      background: #f2f3f5;
      .help-icon {
        display: block;
      }
    }
  }
  .dropdown-box .item-space {
    position: absolute;
    width: 20px;
    top: 0;
    right: -16px;
    height: 80px;
    background-color: transparent;
    &:hover {
      background-color: transparent;
    }
  }
</style>
